import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsSmartComponent } from './notifications-smart/notifications-smart.component';
import { NotificationComponent } from './notification/notification.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';



@NgModule({
  declarations: [
    NotificationsSmartComponent,
    NotificationComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule
  ],
  exports: [
    NotificationsSmartComponent
  ]
})
export class NotificationsModule { }
